import * as React from "react";
import { notification, Button } from "antd";
import { CheckCircleFilled, InfoCircleFilled, CloseCircleFilled } from "@ant-design/icons";
import { t } from 'i18next';

const configNotification = () => {
	const rtl = document.body.dataset.direction === 'rtl';
	notification.config({
		rtl
	});
};

const successNotif = (message) => {
	configNotification();

  notification["success"]({
    message: t('SUCCESS'),
    description: message,
    placement: "bottomRight",
    duration: 9,
    className: "success-alert",
    icon: <CheckCircleFilled style={{ color: "#26bb50" }} />,
  });
};

const confirmNotif = (
  message = t('RECEIVING_NOTIFICATIONS'),
  description = t('RECEIVING_NOTIFICATIONS_DESCRIPTION')
) => {
	configNotification();

  const key = `open${Date.now()}`;
  notification.open({
    message: message,
    description: description,
    // placement: "bottomRight",
    className: "confirm-notification-alert",
    duration: 0,
    btn: (
      <div>
        <Button
          type="primary"
          size="small"
          onClick={() => notification.close(key)}
        >
          {t('ENABLE')}
        </Button>
        <Button
          type="primary"
          size="small"
          onClick={() => notification.close(key)}
        >
          {t('CANCEL')}
        </Button>
      </div>
    ),
    key,
  });
};

/**
 * Shows an info notification
 * @param {string} title - The title of the notification
 * @param {string} message - The notification description or body
 * @param {number} [duration] - The notification duration in seconds
 */
const info = (title, message, duration = 9) => {
	configNotification();
	
  notification.info({
    message: title,
    description: message,
    placement: "bottomRight",
    duration,
    className: "info-notification",
    icon: <InfoCircleFilled style={{ color: '#007aff' }} />,
  });
};

/**
 * Shows an error notification
 * @param {object} config - The config object
 * @param {string} [config.title] - The title of the notification
 * @param {string} config.message - The notification description or body
 * @param {number} [config.duration] - The notification duration in seconds
 */
const error = ({ title = t('ERROR'), message, duration = 9 }) => {
	configNotification();

	notification.error({
    message: title,
    description: message,
    placement: "bottomRight",
    duration: 9,
    className: "error-alert",
    icon: <CloseCircleFilled style={{ color: "#ff3b30" }} />,
  });
};

export { successNotif, confirmNotif, info, error };
